import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { AudioPlayer } from '../../legacy'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'
import {
    loadAudio,
    stopAudio,
    playAudio,
    AUDIO_TOUR,
    AUDIO_LOAD,
    AUDIO_STOP,
    AUDIO_HS,
    AUDIO_MAIN,
} from '../audioManagerActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import compose from 'recompose/compose'

class MobileAudioHandler extends PureComponent {
    init = props => {
        if (!this.audioPlayer) {
            this.audioPlayer = new AudioPlayer(`.TOUR_AUDIO`, { onFailedToPlay: this.onFailedToPlay })
        }

        const { audioUrl } = props
        if (audioUrl && this.audioPlayer.getUrl() !== audioUrl && props.allowedAudio == AUDIO_TOUR) {
            this.props.loadAudio(AUDIO_TOUR)
        }
    }

    componentDidMount() {
        this.init(this.props)

        this.audioPlayer.onEnded(this.handleOnEnded)
        this.audioPlayer.onLoaded(this.handleOnLoaded)

        document.addEventListener('visibilitychange', this.handleOnVisibilityChange)
    }

    componentWillReceiveProps(newProps) {
        this.init(newProps)
    }

    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleOnVisibilityChange)
        this.audioPlayer.destroy()
    }

    /**
     * Called when play fails, autoplay catch
     */
    onFailedToPlay = media => {
        document.addEventListener(
            'touchstart',
            function() {
                media &&
                    this.audioPlayer &&
                    typeof this.audioPlayer.isPlaying == 'function' &&
                    !this.audioPlayer.isPlaying() &&
                    media.play()
            },
            { once: true }
        )
    }

    handleOnVisibilityChange = e => {
        switch (document.visibilityState) {
            case 'hidden':
                if (this.audioPlayer.isPlaying()) this.audioPlayer.stop()
                break
            case 'visible':
                if (!this.audioPlayer.isPlaying() && this.props.allowedAudio == AUDIO_TOUR) this.audioPlayer.play()
                break
            default:
                this.audioPlayer.stop()
        }
    }

    handleOnLoaded = e => {
        if (this.props.allowedAudio == AUDIO_LOAD && this.props.autoplay) this.props.playAudio(AUDIO_TOUR)
    }

    handleOnEnded = e => {
        const { onEnded } = this.props
        onEnded && onEnded(e)
    }

    handlePlayState = () => {
        const { audioUrl, allowedAudio, mainMediaType } = this.props

        if (this.audioPlayer) {
            if (allowedAudio == AUDIO_LOAD) {
                this.audioPlayer.setUrl(audioUrl)
                this.audioPlayer.play()
            } else if (allowedAudio == AUDIO_TOUR) {
                if (this.audioPlayer.ended()) {
                    this.audioPlayer.currentTime(0)
                }
                //play if it's not playing and we are allowed to...
                if (
                    this.props.allowedAudio == AUDIO_TOUR &&
                    this.audioPlayer.isPlaying() == false &&
                    mainMediaType != MEDIA_TYPES.video
                ) {
                    this.audioPlayer.play()
                }
            } else {
                this.audioPlayer.stop()
            }
        }
    }

    render() {
        this.handlePlayState()
        return <audio className={'TOUR_AUDIO'} />
    }
}

const mapStateToProps = state => ({
    autoplay: state.getIn(['audioManager', 'autoplay']),
})

export default compose(
    connect(mapStateToProps),
    connect(mapSelectorsToProps(['audioUrl', 'allowedAudio', 'mainMediaType']), {
        loadAudio,
        stopAudio,
        playAudio,
    })
)(MobileAudioHandler)
